export default __webpack_public_path__ + "static/media/MyFace.89cf375a.jpg";